import { render } from "./awsElasticBlockStore.vue?vue&type=template&id=ed6f1bcc"
import script from "./awsElasticBlockStore.vue?vue&type=script&lang=js"
export * from "./awsElasticBlockStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__